// role types
export const ADMIN = '3SC Admin'
export const GDPC_ADMIN = 'GDPC Admin'
export const NS_ADMIN = 'NS Admin'
export const NS_EDITOR = 'NS Editor'
export const API_USER = 'API User'

// permission types
export const VIEW_BACKEND = 'view-backend'
export const USERS_VIEW = 'users-view'
export const USERS_LIST = 'users-list'
export const USERS_CREATE = 'users-create'
export const USERS_EDIT = 'users-edit'
export const USERS_DELETE = 'users-delete'
export const USERS_DEACTIVATE = 'users-deactivate'
export const USERS_REACTIVATE = 'users-reactivate'
export const CONTENT_PUBLISH = 'content-publish'
export const CONTENT_CREATE = 'content-create'
export const CONTENT_EDIT = 'content-edit'
export const CONTENT_DELETE = 'content-delete'
export const CONTENT_VIEW = 'content-view'
export const HAZARD_TYPE_CREATE = 'hz-type-create'
export const ALL_ORGANISATIONS = 'organisations_all'
export const TERMS_UPDATE = 'terms-update'
